import intl from "react-intl-universal";


import {UndoableAction} from "./UndoableAction";


import {undoManager} from "./UndoManager";
import {snackBarRef} from "../../stores/snackbarRef";


export const undoableFunctionCall = async (undoableAction: UndoableAction, successMessage: string) => {
    await undoManager.execute(undoableAction);
    snackBarRef.current!.enqueueSnackbar({
        message: successMessage,
        actionDef: {
            text: intl.get('snackbar.undo').d('Undo'),
            onClick: () => undoManager.undo(undoableAction),
        },
    })
}